import React from "react";
import { Create, SimpleForm } from 'react-admin';

import { SaveWithCancelToolbar } from '../../../components/toolbars/SaveWithCancelToolbar';

import { CustomerCompanyCreateForm } from './CreateForm';


export const CompanyCreate = (props) => (
	<Create {...props}>
		<SimpleForm submitOnEnter={false} toolbar={<SaveWithCancelToolbar />} redirect="list">
			<CustomerCompanyCreateForm />
		</SimpleForm>
	</Create>
);
